import { z } from 'zod'
import { UserEmailSchema } from '@/core/infrastructure/schemas/utils/UserEmailSchema.ts'
import { UserIdentifierSchema } from '@/core/infrastructure/schemas/utils/UserIdentifierSchema.ts'
import { UserGenderSchema } from '@/core/infrastructure/schemas/utils/UserGenderSchema.ts'
import { UserListRolesSchema } from '@/core/infrastructure/schemas/utils/UserListRolesSchema.ts'
import {
  UserBirthdateSchema,
} from '@/core/infrastructure/schemas/utils/UserBirthdateSchema.ts'
import { UserGender } from '@/core/domain/resources/enums/UserGender.ts'
import { UserRole } from '@/core/domain/resources/enums/UserRole.ts'

/**
 * Représentation du payload pour créer ou modifier un utilisateur
 */
export const UserInputSchema = z.object({
  identifier: UserIdentifierSchema,
  firstname: z.string().min(1, 'Le prénom est requis').max(150, 'Le prénom est trop long'),
  lastname: z.string().min(1, 'Le nom est requis').max(150, 'Le nom est trop long'),
  email: UserEmailSchema,
  gender: UserGenderSchema,
  roles: UserListRolesSchema,
  birthdate: UserBirthdateSchema
})
export type UserInputEntity = z.infer<typeof UserInputSchema>

/**
 * Représentation du payload pour filtrer les utilisateurs
 */
export const UserSearchRequestSchema = z.object({
  q: z.string().nullable().default(null),
  roles: z.array(z.nativeEnum(UserRole.Values)).nullable().default([]),
  genders: z.array(z.nativeEnum(UserGender.Values)).nullable().default([]),
  blocked: z.boolean().nullable().default(null),
  emailVerified: z.boolean().nullable().default(null)
})
export type UserSearchRequestEntity = z.infer<typeof UserSearchRequestSchema>


/**
 * Représentation de la réponse du reset de mot de passe
 */
export const UserResetPasswordSchema = z.object({
  identifier: UserIdentifierSchema,
  password: z.string().min(8)
})
export type UserResetPasswordEntity = z.infer<typeof UserResetPasswordSchema>